/* eslint-disable sonarjs/cognitive-complexity */
/* eslint-disable max-params */
/* eslint-disable complexity */
/* eslint-disable max-lines */
// 9fbef606107a605d69c0edbcd8029e5d
import React from 'react';
import PropTypes from 'prop-types';
import dynamic from 'next/dynamic';
import withStyles from '@tcp/core/src/components/common/hoc/withStyles';
import LabelsContext from '@tcp/core/src/components/common/context/LabelsContext';
import Anchor from '@tcp/core/src/components/common/atoms/Anchor';
import Row from '@tcp/core/src/components/common/atoms/Row';
import Col from '@tcp/core/src/components/common/atoms/Col';
import BodyCopy from '@tcp/core/src/components/common/atoms/BodyCopy';
import ForgotPasswordContainer from '@tcp/core/src/components/features/account/ForgotPassword';
import PasswordForm from '@tcp/core/src/components/features/account/LoginPage/molecules/PasswordForm';
import { setContactFormValuesInSS } from '@tcp/core/src/components/features/CnC/SinglePageCheckout/molecules/ContactForm/ContactForm.util';
import {
  isCanada,
  scrollPage,
  getUrlParameter,
  routerPush,
  getViewportInfo,
} from '@tcp/core/src/utils';
import constants from '@tcp/core/src/components/features/account/LoginPage/LoginPage.constants';
import ResetPassword from '@tcp/core/src/components/features/account/ResetPasswordRoute';
import {
  getLabelFromCopyOrFromTranslation,
  getDynamicLabelValues,
} from '@tcp/core/src/utils/labels/labelUtilty';
import LoginSelectionForm from '../../../molecules/LoginSelectionForm';
import LoginSelectionFormV2 from '../../../molecules/LoginSelectionFormV2';
import LoginHeader from '../../../molecules/LoginHeader';
import styles from './styles/LoginPasswordSection.styles';
import {
  GLOBAL_LOGIN_LABELS,
  GlobalLoginLabels,
  lblCreateAcntHelp1v1,
  lblCreateAcntHelp2v1,
  lblLoginBackToBag,
  lblLoginCreateAcctHelp,
  lblLoginDifferentEmail,
  lblLoginEarnPoint,
  lblLoginForgotPwdCta,
  lblLoginNot,
  lblLoginWelcomeScreenTitle,
  lblLoginv2ChooseLogin,
} from '../../../../../../../utils/labels/globalLogin.labels';
import {
  GLOBAL_ACCESSIBILITY_LABELS,
  GlobalAccessibilityLabels,
  myPlaceRewards,
} from '../../../../../../../utils/labels/globalAccessibility.labels';
import GlobalAccountDrawerLabels, {
  GLOBAL_ACCOUNT_DRAWER_LABELS,
  lblAccountDrawerLogout,
} from '../../../../../../../utils/labels/globalAccountDrawer.labels';
import {
  GlobalGenericLabels,
  GLOBAL_GENERIC_LABELS,
  lblCreditCard,
} from '../../../../../../../utils/labels/globalGeneric.labels';

const LogOutPageContainer = dynamic(() =>
  // eslint-disable-next-line extra-rules/no-commented-out-code
  import(/* webpackChunkName: "logout-page" */ '../../../../Logout/container/LogOut.container')
);

class LoginPasswordSection extends React.PureComponent {
  constructor(props) {
    super(props);
    this.isCanada = isCanada();
    this.parentRef = React.createRef();
    this.loginLabels = getLabelFromCopyOrFromTranslation(GLOBAL_LOGIN_LABELS, GlobalLoginLabels);
  }

  componentDidMount() {
    const redirectFromReset = getUrlParameter('redirectFromReset');
    const {
      setRememberUser,
      onEmailSubmit,
      initialValues,
      isRememberedUser,
      maskedPhoneNumber,
      isExistingUserFromSS,
      otpToken = false,
    } = this.props;
    if (redirectFromReset && redirectFromReset.length > 0) {
      routerPush('/home?target=login', '/home/login', { shallow: true });
    }
    setRememberUser();
    if (this.parentRef && this.parentRef.current) {
      setTimeout(() => {
        this.parentRef.current.scrollIntoView();
      }, 0);
    }
    if (isRememberedUser && !maskedPhoneNumber && (!isExistingUserFromSS || !otpToken)) {
      onEmailSubmit(initialValues);
    }
  }

  componentDidUpdate(prevProps) {
    const { currentForm } = this.props;

    if (currentForm !== prevProps.currentForm) {
      scrollPage();
    }
  }

  showForgotPasswordForm = () => {
    const { openModal, trackAnalyticsClick } = this.props;
    const forgotPasswordLabel = this.loginLabels[lblLoginForgotPwdCta];
    trackAnalyticsClick({
      metric33: '1',
      eVar150: forgotPasswordLabel,
      customEvents: ['event33'],
    });
    openModal({
      component: 'login',
      componentProps: {
        currentForm: constants.PAGE_TYPE.FORGOT_PASSWORD,
      },
    });
  };

  showLoginForm = () => {
    const { openModal, trackAnalyticsClick } = this.props;
    const forgotPasswordLabel = this.loginLabels[lblLoginForgotPwdCta];
    trackAnalyticsClick({
      metric33: '1',
      eVar150: forgotPasswordLabel,
      customEvents: ['event33'],
    });
    openModal({
      component: 'login',
      componentProps: {
        currentForm: constants.PAGE_TYPE.LOGIN,
      },
    });
  };

  showCreateAccountForm = () => {
    const {
      onClose,
      openOverlay,
      closeModal,
      fullPage,
      closeOverlay,
      fullPageAuthEnabled,
      variation,
    } = this.props;
    const { pathname = 'referrer' } = (window && window.location) || {};
    if (variation !== 'favorites' && (fullPage || fullPageAuthEnabled)) {
      closeOverlay();
      routerPush(`/home?target=register&successtarget=${pathname}`, '/home/register');
    } else {
      openOverlay({
        component: 'createAccount',
        variation: 'primary',
      });
    }
    onClose();
    closeModal();
  };

  getSignOutSection = (
    { isRememberedUser, logoutlabels, userName },
    isV2Flow,
    logoutLabel,
    isNewLoginScreen,
    fromPlccICLogin
  ) => {
    return isRememberedUser || fromPlccICLogin ? (
      <BodyCopy component="div" className="elem-pb-XXS">
        <BodyCopy
          fontFamily="primary"
          fontSize="fs14"
          textAlign={`${isV2Flow || (isRememberedUser && !fromPlccICLogin) ? 'center' : 'left'}`}
          fontWeight={
            isNewLoginScreen && (isRememberedUser || fromPlccICLogin) ? 'semibold' : 'normal'
          }
        >
          {`${this.loginLabels[lblLoginNot]} ${fromPlccICLogin ? 'You' : userName}? `}
          <Anchor
            underline
            fontSizeVariation="medium"
            anchorVariation="primary"
            onClick={this.showLoginForm}
          >
            <LogOutPageContainer
              labels={logoutlabels}
              underline
              isV2Flow={isV2Flow}
              logoutLabel={logoutLabel}
              isLoginFlow={true}
              fromPlccICLogin={fromPlccICLogin}
            />
          </Anchor>
        </BodyCopy>
      </BodyCopy>
    ) : null;
  };

  getCreateAccountHelp = ({ fullPage }) => {
    return !fullPage ? (
      <BodyCopy fontFamily="secondary" fontSize="fs12" textAlign="center">
        {this.loginLabels[lblLoginCreateAcctHelp]}
      </BodyCopy>
    ) : (
      <>
        <BodyCopy fontFamily="secondary" fontSize="fs12" textAlign="center">
          {this.loginLabels[lblCreateAcntHelp1v1]}
        </BodyCopy>
        <BodyCopy fontFamily="secondary" fontSize="fs12" textAlign="center">
          {this.loginLabels[lblCreateAcntHelp2v1]}
        </BodyCopy>
      </>
    );
  };

  renderTopUserInfo = (
    isRememberedUser,
    rememberedEmail,
    isV2Flow,
    logoutLabel,
    isNewLoginScreen,
    fromPlccICLogin,
    headerLabel
  ) => {
    return (
      <BodyCopy
        component="div"
        textAlign="center"
        className={isNewLoginScreen ? 'elem-mb-REG  elem-mt-XS' : 'elem-mb-LRG'}
      >
        {!isRememberedUser && !fromPlccICLogin && (
          <Anchor
            noLink
            underline
            fontSizeVariation="large"
            fontSize="fs14"
            anchorVariation="primary"
            dataLocator="Use a Different Email"
            onClick={this.onClickDifferentEmail}
            className="different-email-link"
          >
            {this.loginLabels[lblLoginDifferentEmail]}
          </Anchor>
        )}
        {(isRememberedUser || fromPlccICLogin) &&
          isNewLoginScreen &&
          this.getSignOutSection(
            this.props,
            isV2Flow,
            logoutLabel,
            isNewLoginScreen,
            fromPlccICLogin
          )}
        {isRememberedUser && !isNewLoginScreen && (
          <BodyCopy
            textAlign="center"
            fontWeight="bold"
            fontSize="fs14"
            fontFamily="secondary"
            className="elem-mt-XL_1"
          >
            {rememberedEmail}
          </BodyCopy>
        )}
        {isNewLoginScreen && (isRememberedUser || fromPlccICLogin) && (
          <BodyCopy
            component="p"
            textAlign={fromPlccICLogin ? 'left' : 'center'}
            fontSize="fs14"
            fontWeight="bold"
            fontFamily="secondary"
            className="elem-mt-XL_1"
          >
            {fromPlccICLogin
              ? this.renderPLCCsubHeaderText(headerLabel)
              : this.loginLabels[lblLoginv2ChooseLogin]}
          </BodyCopy>
        )}
        {isRememberedUser &&
          !isNewLoginScreen &&
          this.getSignOutSection(this.props, isV2Flow, logoutLabel, isNewLoginScreen)}
      </BodyCopy>
    );
  };

  getLoyaltyLocation = (variation) => {
    return variation === 'checkout' ? 'checkout-popup' : 'Login';
  };

  onClickDifferentEmail = (e) => {
    e.preventDefault();
    setTimeout(() => {
      const {
        saveExistingUserResponse,
        trackAnalyticsClick,
        setShowBriteErrorMessage,
        setBriteErrorMessageData,
        isBriteVerifyForLoginEnabled,
      } = this.props;
      const useDifferentEmailLabel = this.loginLabels[lblLoginDifferentEmail];
      trackAnalyticsClick({
        metric33: '1',
        eVar150: useDifferentEmailLabel,
        customEvents: ['event33'],
      });
      saveExistingUserResponse('');
      setContactFormValuesInSS();
      if (isBriteVerifyForLoginEnabled) {
        setShowBriteErrorMessage(false);
        setBriteErrorMessageData(false);
      }
    }, 0);
  };

  onCheckoutAsGuest = () => {
    const { handleContinueAsGuest } = this.props;
    handleContinueAsGuest();
  };

  submitLogin = (values) => {
    const { existingUserResponse, onSubmit, rememberedEmail } = this.props;
    let { emailAddress } = existingUserResponse || {};
    if (rememberedEmail) {
      emailAddress = rememberedEmail;
    }
    const payload = { ...values, emailAddress };
    onSubmit(payload);
  };

  rememberedEmailRenderer = (
    isNewLoginScreen,
    emailAddress,
    isRememberedUser,
    rememberedEmail,
    fromPlccICLogin
  ) => {
    let email;
    if (isNewLoginScreen) {
      if (isRememberedUser) email = rememberedEmail;
      else email = emailAddress;
    } else {
      email = emailAddress;
    }
    const fontWeight = () => {
      if (isNewLoginScreen) {
        if (isRememberedUser) return 'normal';
        return 'bold';
      }
      return 'extrabold';
    };
    return (
      <BodyCopy
        textAlign={fromPlccICLogin ? 'left' : 'center'}
        fontWeight={fontWeight()}
        fontSize={isNewLoginScreen ? 'fs14' : 'fs13'}
        fontFamily="secondary"
        component="span"
        className={isNewLoginScreen && isRememberedUser ? 'elem-mt-XL' : ''}
      >
        {` ${email}`}
      </BodyCopy>
    );
  };

  renderPLCCsubHeaderText = (headerLabel) => {
    return (
      <BodyCopy className="plcc-text" textAlign="left">
        <BodyCopy component="span" fontWeight="medium" fontSize="fs16" fontFamily="secondary">
          {getDynamicLabelValues('dynamic.cart.lbl_plcc_ic_login_modal_subheader')}
        </BodyCopy>
        <span>
          <BodyCopy
            component="span"
            fontWeight="extrabold"
            fontSize="fs16"
            className="text-style-1"
            fontFamily="secondary"
          >
            {headerLabel[0] ? `${headerLabel[0]} ` : ''}
          </BodyCopy>
          <BodyCopy
            component="span"
            fontWeight="extrabold"
            fontSize="fs16"
            className="text-style-2"
            fontFamily="secondary"
          >
            {headerLabel[1] ? `${headerLabel[1]} ` : ''}
          </BodyCopy>
          <BodyCopy
            component="span"
            fontWeight="extrabold"
            fontSize="fs16"
            className="text-style-3"
            fontFamily="secondary"
          >
            {headerLabel[2] ? `${headerLabel[2]} ` : ''}
          </BodyCopy>
          <BodyCopy
            component="span"
            fontWeight="extrabold"
            fontSize="fs16"
            className="text-style-4"
            fontFamily="secondary"
          >
            {getLabelFromCopyOrFromTranslation(
              `${GLOBAL_GENERIC_LABELS}.${lblCreditCard}`,
              GlobalGenericLabels
            )}
          </BodyCopy>
        </span>
      </BodyCopy>
    );
  };

  determineCssClass = (loginFlowUXEnhancementEnabled, fromPlccICLogin, isRememberedUser) => {
    if (!fromPlccICLogin && !isRememberedUser) {
      return loginFlowUXEnhancementEnabled ? 'center-align elem-mt-LRG' : 'center-align';
    }
    return '';
  };

  getHeaderContent = (
    headerLabel,
    emailAddress,
    isRememberedUser,
    rememberedEmail,
    isV2Flow,
    isLoginWithOTPEnabled,
    logoutLabel,
    isNewLoginScreen,
    lblLoginCheckoutModalHeading1,
    fromPlccICLogin,
    loginFlowUXEnhancementEnabled
  ) => {
    return (
      <>
        <BodyCopy textAlign="center" component="div" className="heading-container">
          {!isNewLoginScreen &&
            (isCanada() ? (
              <BodyCopy component="span" className="my-place-rewards elem-ml-XXXS elem-mt-XS">
                <BodyCopy
                  component="div"
                  fontSize="fs13"
                  fontFamily="secondary"
                  textAlign="center"
                  fontWeight="bold"
                >
                  {this.loginLabels[lblLoginWelcomeScreenTitle]}
                </BodyCopy>
              </BodyCopy>
            ) : (
              <BodyCopy className="elem-mt-XS">
                <BodyCopy component="span" className="my-place-rewards elem-ml-XXXS">
                  <BodyCopy
                    component="span"
                    fontSize="fs13"
                    fontFamily="secondary"
                    textAlign="center"
                    fontWeight="bold"
                  >
                    {isLoginWithOTPEnabled && this.loginLabels[lblLoginEarnPoint]}
                    {!isLoginWithOTPEnabled && lblLoginCheckoutModalHeading1}
                  </BodyCopy>
                  <BodyCopy textAlign="center">
                    <BodyCopy
                      component="span"
                      fontWeight="extrabold"
                      fontSize="fs13"
                      className="text-style-1"
                      fontFamily="secondary"
                    >
                      {headerLabel[0] ? `${headerLabel[0]} ` : ''}
                    </BodyCopy>
                    <BodyCopy
                      component="span"
                      fontWeight="extrabold"
                      fontSize="fs13"
                      className="text-style-2"
                      fontFamily="secondary"
                    >
                      {headerLabel[1] ? `${headerLabel[1]} ` : ''}
                    </BodyCopy>
                    <BodyCopy
                      component="span"
                      fontWeight="extrabold"
                      fontSize="fs13"
                      className="text-style-3"
                      fontFamily="secondary"
                    >
                      {headerLabel[2] ? headerLabel[2] : ''}
                    </BodyCopy>
                  </BodyCopy>
                </BodyCopy>
              </BodyCopy>
            ))}
        </BodyCopy>
        <div
          className={this.determineCssClass(
            loginFlowUXEnhancementEnabled,
            fromPlccICLogin,
            isRememberedUser
          )}
        >
          {isNewLoginScreen && !isRememberedUser && !fromPlccICLogin && (
            <BodyCopy
              component="span"
              textAlign="center"
              fontSize="fs14"
              fontWeight={loginFlowUXEnhancementEnabled ? 'semibold' : 'bold'}
              fontFamily="secondary"
              className={!loginFlowUXEnhancementEnabled ? 'elem-mt-MED' : 'elem-mr-XXS'}
            >
              {`${this.loginLabels[lblLoginv2ChooseLogin]}`}
              {((!isRememberedUser && !fromPlccICLogin) || isNewLoginScreen) &&
                this.rememberedEmailRenderer(
                  isNewLoginScreen,
                  emailAddress,
                  isRememberedUser,
                  rememberedEmail,
                  fromPlccICLogin
                )}
            </BodyCopy>
          )}
        </div>
        {!isNewLoginScreen && (
          <BodyCopy component="div" textAlign="center" className="underline elem-mt-MED" />
        )}
        {this.renderTopUserInfo(
          isRememberedUser,
          rememberedEmail,
          isV2Flow,
          logoutLabel,
          isNewLoginScreen,
          fromPlccICLogin,
          headerLabel
        )}
      </>
    );
  };

  renderForgotPassword = ({ currentForm }) => {
    return (
      currentForm === constants.PAGE_TYPE.FORGOT_PASSWORD && (
        <ForgotPasswordContainer showForgotPasswordForm={this.showLoginForm} />
      )
    );
  };

  renderResetPassword = ({ currentForm, queryParams }) => {
    return (
      currentForm === constants.PAGE_TYPE.RESET_PASSWORD && (
        <ResetPassword backToLoginAction={this.showLoginForm} queryParams={queryParams} />
      )
    );
  };

  getIsOTPMobile = ({ isLoginWithOTPEnabled }) => {
    const { isMobile } = getViewportInfo() || {};
    return isMobile && isLoginWithOTPEnabled;
  };

  static contextType = LabelsContext;

  // eslint-disable-next-line sonarjs/cognitive-complexity
  render() {
    const {
      formErrorMessage,
      loginErrorMessage,
      initialValues,
      showRecaptcha,
      resetForm,
      className,
      queryParams,
      currentForm,
      variation,
      tooltipContent,
      resetLoginState,
      userplccCardNumber,
      userplccCardId,
      isLoading,
      isRememberedUser,
      closeOverlay,
      isResetPassCodeValidationEnabled,
      closeModal,
      fullPage,
      setUserEmailAddress,
      existingUserResponse,
      backToBag,
      rememberedEmail,
      isV2Flow,
      trackAnalyticsPageView,
      trackAnalyticsClick,
      isShowPhoneLoginOption,
      isLoginWithOTPEnabled,
      maskedPhoneNumber,
      isLoginWithEmailOTPEnabled,
      setRememberUser,
      fromPlccICLogin,
      userName,
      isLoginModal,
      isPlccLoginLoading,
      phoneCountryCode,
      loginFlowUXEnhancementEnabled,
      setShowBriteErrorMessage,
      setBriteErrorMessageData,
      isBriteVerifyForLoginEnabled,
    } = this.props;
    const { extraConfig } = this.context;
    const { isNewLoginScreen: isNewLoginScreenExtraConfig } = extraConfig || {};
    const isNewLoginScreen = fromPlccICLogin ? true : isNewLoginScreenExtraConfig;
    const { emailAddress, phoneCountryCode: phoneCountryCodeSS } = existingUserResponse || {};
    const {
      lbl_login_checkout_modal_heading: lblLoginCheckoutModalHeading,
      lbl_login_checkout_modal_heading_1: lblLoginCheckoutModalHeading1,
    } = getDynamicLabelValues('dynamic.account_d');

    const headerLabel = getLabelFromCopyOrFromTranslation(
      `${GLOBAL_ACCESSIBILITY_LABELS}.${myPlaceRewards}`,
      GlobalAccessibilityLabels
    ).split(' ');
    const logoutLabel = getLabelFromCopyOrFromTranslation(
      `${GLOBAL_ACCOUNT_DRAWER_LABELS}.${lblAccountDrawerLogout}`,
      GlobalAccountDrawerLabels
    );
    const requiredProps = {
      onSubmit: this.submitLogin,
      formErrorMessage,
      loginErrorMessage,
      initialValues,
      showRecaptcha,
      isRememberedUser,
      showForgotPasswordForm: this.showForgotPasswordForm,
      resetForm,
      className,
      onCreateAccountClick: this.showCreateAccountForm,
      variation,
      handleContinueAsGuest: this.onCheckoutAsGuest,
      tooltipContent,
      resetLoginState,
      userplccCardNumber,
      userplccCardId,
      isLoading,
      closeOverlay,
      closeModal,
      isResetPassCodeValidationEnabled,
      fullPage,
      setUserEmailAddress,
      userSavedEmail: emailAddress,
      isV2Flow,
      isShowPhoneLoginOption,
      isLoginWithOTPEnabled,
      maskedPhoneNumber,
      trackAnalyticsPageView,
      trackAnalyticsClick,
      isLoginWithEmailOTPEnabled,
      setRememberUser,
      isNewLoginScreen,
      isLoginModal,
      rememberedEmail,
      phoneCountryCode,
      phoneCountryCodeSS,
      loginFlowUXEnhancementEnabled,
      setShowBriteErrorMessage,
      setBriteErrorMessageData,
      isBriteVerifyForLoginEnabled,
    };
    const LoginSelectionComp = isNewLoginScreen ? LoginSelectionFormV2 : LoginSelectionForm;
    const isOTPMobile = this.getIsOTPMobile({ isLoginWithOTPEnabled });
    const loginHeaderLabel = fromPlccICLogin
      ? `${lblLoginCheckoutModalHeading.replace('!', '')} ${userName}!`
      : lblLoginCheckoutModalHeading;
    return (
      <div className={className}>
        {isLoginWithOTPEnabled && (
          <LoginHeader
            variation={isV2Flow ? 'checkout' : variation}
            fullPage={fullPage}
            headingLabel={loginHeaderLabel}
            isLoginWithOTPEnabled={isLoginWithOTPEnabled}
            isV2Flow={isV2Flow}
            fromPlccICLogin={fromPlccICLogin}
            loginFlowUXEnhancementEnabled={loginFlowUXEnhancementEnabled}
          />
        )}
        {!isLoginWithOTPEnabled && (
          <>
            <BodyCopy
              fontSize="fs26"
              fontFamily="secondary"
              textAlign="center"
              className="elem-mt-LRG"
              fontWeight="extrabold"
            >
              {lblLoginCheckoutModalHeading}
            </BodyCopy>
          </>
        )}

        {this.getHeaderContent(
          headerLabel,
          emailAddress,
          isRememberedUser,
          rememberedEmail,
          isV2Flow,
          isLoginWithOTPEnabled,
          logoutLabel,
          isNewLoginScreen,
          lblLoginCheckoutModalHeading1,
          fromPlccICLogin,
          loginFlowUXEnhancementEnabled
        )}
        <Row fullBleed={`${isOTPMobile && 'fullBleed'}}`}>
          <Col
            colSize={{
              small: 6,
              medium: 8,
              large: `${variation === 'checkout' && !isLoginWithOTPEnabled ? 7 : 12}`,
            }}
            className={`${isV2Flow && 'elem-pl-LRG elem-pr-LRG'} loginForm`}
          >
            {(!currentForm || currentForm === constants.PAGE_TYPE.LOGIN) && (
              <>
                {isShowPhoneLoginOption && (
                  <LoginSelectionComp
                    {...requiredProps}
                    onGenerateOTP={this.props.onGenerateOTP}
                    existingUserResponse={existingUserResponse}
                    isCanada={this.isCanada}
                    fromPlccICLogin={fromPlccICLogin}
                    isPlccLoginLoading={isPlccLoginLoading}
                  />
                )}
                {!isShowPhoneLoginOption && (
                  <PasswordForm
                    onGenerateOTP={this.props.onGenerateOTP}
                    {...requiredProps}
                    emailAddress={emailAddress}
                    fromPlccICLogin={fromPlccICLogin}
                    isPlccLoginLoading={isPlccLoginLoading}
                  />
                )}
              </>
            )}
            {this.renderForgotPassword({ currentForm })}
            {this.renderResetPassword({ currentForm, queryParams })}
            {isV2Flow && (
              <BodyCopy component="div" textAlign="center">
                <Anchor
                  underline
                  fontSizeVariation="large"
                  fontSize="fs14"
                  anchorVariation="primary"
                  dataLocator="Back to Bag"
                  onClick={backToBag}
                  className="elem-mt-MED_2"
                  textAlign="center"
                >
                  {this.loginLabels[lblLoginBackToBag]}
                </Anchor>
              </BodyCopy>
            )}
          </Col>
        </Row>
      </div>
    );
  }
}

LoginPasswordSection.propTypes = {
  onSubmit: PropTypes.func.isRequired,
  loginErrorMessage: PropTypes.string,
  initialValues: PropTypes.shape({}).isRequired,
  showRecaptcha: PropTypes.bool,
  openModal: PropTypes.func,
  queryParams: PropTypes.shape({}).isRequired,
  currentForm: PropTypes.string,
  handleContinueAsGuest: PropTypes.func.isRequired,
  formErrorMessage: PropTypes.shape({}).isRequired,
  userplccCardNumber: PropTypes.string.isRequired,
  userplccCardId: PropTypes.string.isRequired,
  logoutlabels: PropTypes.shape({}),
  onClose: PropTypes.func.isRequired,
  openOverlay: PropTypes.func.isRequired,
  closeModal: PropTypes.func.isRequired,
  resetForm: PropTypes.bool.isRequired,
  className: PropTypes.string.isRequired,
  variation: PropTypes.string.isRequired,
  tooltipContent: PropTypes.string.isRequired,
  resetLoginState: PropTypes.func.isRequired,
  isLoading: PropTypes.bool.isRequired,
  isRememberedUser: PropTypes.bool.isRequired,
  closeOverlay: PropTypes.func,
  isResetPassCodeValidationEnabled: PropTypes.bool,
  fullPage: PropTypes.bool,
  fullPageAuthEnabled: PropTypes.bool,
  isLoginWithOTPEnabled: PropTypes.bool,
  setRememberUser: PropTypes.func,
};

LoginPasswordSection.defaultProps = {
  loginErrorMessage: '',
  showRecaptcha: false,
  openModal: () => {},
  currentForm: constants.PAGE_TYPE.LOGIN,
  closeOverlay: () => {},
  isResetPassCodeValidationEnabled: false,
  fullPage: false,
  fullPageAuthEnabled: false,
  setRememberUser: () => {},
};

export default withStyles(LoginPasswordSection, styles);
export { LoginPasswordSection as LoginPasswordSectionVanilla };
